import React from 'react';
import { Card } from '../UI';
import HouseIcon from './HouseIcon';
import classes from './ProjectCard.module.css';

const ProjectCard = ({ project, onClick }) => {
  return (
    <div className={classes.projectCard} onClick={() => onClick(project._id)}>
      <Card>
        <div className={classes.cardContent}>
          <div className={classes.textContent}>
            <h3 className={classes.projectName}>{project.name}</h3>
            <p className={classes.deviceCount}>
              {project.devicesCount || 0} {project.devicesCount === 1 ? 'device' : 'devices'}
            </p>
          </div>
          <div className={classes.icon}>
            <HouseIcon />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ProjectCard;

